import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import Banner from './Banner';
import InsideContact from './InsideContact';


class About extends Component {


    render() {
        return (
            <div>
                <Banner
                    headText="About Us"
                    subHeadText="Providing our customers with cutting edge business solutions through technology for over 27 years"
                    subBoldText="INNOVATIVE. AFFORDABLE. PRACTICAL."
                    img="interior-1.jpg"
                />
                <div className="main-container">
                    <div className="container">
                        <div className="row">


                            <div className="col-lg-9 col-md-6 col-sm-12 margin5-0">
                                <h4>WELCOME TO AUTOMATED CONCEPTS</h4>
                                <p>
                                    Automated Concepts is a privately owned business specializing in the creation of custom software and hardware solutions 
                                    to meet the needs of small to medium business. We do this by taking the time to understand our clients special technology 
                                    needs and then craft solutions dedicated to meet those needs. We make sure that they are practical, productive and cost 
                                    effective. We do not oversell products our clients do not need, nor do we cut corners just to get a product delivered. 
                                    We take immense care and pride in what we do, and our satisfied clients testify to the quality of work we deliver. 
                                    Whether your needs lie in CRM, Data Management, Manufacturing, Trade Shows, Healthcare, Real Estate, Retail and Wholesale, 
                                    Financial Services and many other industries as well, Automated Concepts can develop a technology solution to perfectly 
                                    match your specific needs. 
                                </p>
                                <br />
                                <h4>HUMBLE BEGINNINGS</h4>
                                <p>
                                    Automated Concepts got its start back in 1993, when the owner observed a business struggling to find a product to meet a unique 
                                    technology challenge. Knowing that he could provide a different and innovative approach to meet this challenge, he put aside 
                                    his normal activities and developed an application that successfully resolved their problem. He soon noticed that this business 
                                    was not alone in the struggles to make technology an effective business tool. His unique and personal approach to problem solving 
                                    with local business was both successful and well appreciated. Since then over the past 27 years Automated Concepts has been 
                                    providing clients and SMBs with cutting edge business solutions through technology. In addition Automated Concepts cultivated a 
                                    special group of technology professionals with extensive experience in business process analysis and application design & development.
                                </p>
                                <br />
                                <h4>MAKING IT PERSONAL</h4>
                                <p>
                                    What makes Automated Concepts so unique and successful is we take the time to fully understand the challenges or goals a business 
                                    is seek to improve on. We take and make their challenges personal. Our philosophy is to create long-term relationships with our 
                                    clients in order to provide them with the best affordable solutions possible. We design these solutions confident we understand just 
                                    how to meet their exact specifications. And the pride we take is not just in the products we can deliver, but in the satisfaction our 
                                    clients have expressed through the longevity of our relationships. They are confident Automated Concepts is there for them, from 
                                    solution development to application delivery to product support and service. We make it personal, and it shows. 
                                </p>
                                <br />
                                <h4>WE ARE HERE TO MAKE YOUR BUSINESS THE BEST IT CAN BE</h4>
                                <p>
                                    Regardless of whether you are a small family run business or a large fortune 500 company, we will take the time to get to know you and 
                                    understand your individual business requirements. We'll employ our extensive knowledge and innovative style to recommend, develop, 
                                    implement and support the best solution to meet your specific requirements. If what you need does not exist, we will build it from the 
                                    ground up. If you already have a system in place but there are gaps in functionality or productivity, we can build enhancements that 
                                    can bridge those gapes without starting from scratch. All this with a critical eye towards being cost effective in both time and money.
                                </p>
                                <br />
                                <h4>HOW WE HELP YOU?</h4>
                                <p>
                                    Contact us today, let us explore with you how we can help your business be all it should be!
                                </p>
                            </div>

                            <InsideContact />

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(About);


// WEBPACK FOOTER //
// ./src/components/About.js